import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useExpertSupportConversationHistory } from "./ExpertSupportConversationHistoryHook";

// Set the default state values for each context
const ExpertSupportConversationHistoryContext = /*#__PURE__*/createContext({});
export const ExpertSupportConversationHistoryContextProvider = ({
  children
}) => {
  const expertSupportConversationHistory = useExpertSupportConversationHistory();
  const historyListValue = useMemo(() => ({
    ...expertSupportConversationHistory
  }), [expertSupportConversationHistory]);
  return /*#__PURE__*/React.createElement(ExpertSupportConversationHistoryContext.Provider, {
    value: historyListValue
  }, children);
};
export const useExpertSupportConversationHistoryContext = () => {
  return useContext(ExpertSupportConversationHistoryContext);
};
ExpertSupportConversationHistoryContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};